<i18n>
{
  "fr": {
    "export-data-title": "Exportation de données -",
    "close": "Fermer",
    "measured-parameter": "Paramètres mesurés",
    "reset-bounds": "Réinitialiser",
    "from": "Date de début (à 00:00)",
    "to": "Date de fin (à 00:00 non inclus)",
    "aggregation-mode": "Aggrégation temporelle",
    "stats": "Type d'aggrégation",
    "raw": "Données brutes",
    "RAW": "Données brutes",
    "hh": "Horaire",
    "HH": "Horaire",
    "dd": "Journalière",
    "DD": "Journalière",
    "mm": "Mensuelle",
    "MM": "Mensuelle",
    "yyyy": "Anuelle",
    "YYYY": "Anuelle",
    "MAX": "Maximum",
    "AVG": "Moyenne",
    "MIN": "Minimum",
    "launch-export": "Lancer l'extraction",
    "download-file": "Télécharger le fichier (CSV) | Télécharger les fichiers (CSV)",
    "measured-parameters": "Paramètres mesurés disponibles",
    "date-selection": "Sélection temporelle",
    "aggregation-option": "Options d'aggrégations",
    "utc-offset": "Offset UTC",
    "run-step-fetch": "Récupération des données...",
    "run-step-merge": "Fusion des séries temporelles...",
    "run-step-generate": "Génération du fichier CSV...",
    "run-step-null": "Veuillez patienter...",
    "reset-export": "Faire un autre export",
    "other-option": "Autres options",
    "nodata-value": "Valeur \"no data\"",
    "remote": "provisoire",
    "validated": "validée",
    "observation-point-csv-label": "Point d'eau",
    "public-id-label": "Numéro cantonal",
    "needed-stats-label": "Aggrégation temporelle",
    "aggregation-mode-label": "Type d'aggrégation",
    "date-range-label": "Période d'affichage",
    "count-validated-label": "Nombre de données validées",
    "count-remote-label": "Nombre de données provisoires",
    "out-of-range-export-dd": "L'export de données journalières est limitée à une période de 10 ans",
    "out-of-range-export-raw": "L'export de données brutes est limitée à une période de 2 ans",
    "available-data-from": "Disponible du",
    "available-data-to": "au",
    "next": "Suivant",
    "return": "Retour",
    "export-digest-title": "Résumé de l'extraction -",
    "digest-extract-from": "Du",
    "digest-extract-to": "Au",
    "digest-extract-from-time": "à 00:00",
    "digest-extract-to-time": "à 00:00 non inclus",
    "extract-out-of-range": "Pas de données sur la page de temps sélectionné. Disponibilité pour ce paramètre: ",
    "digest-measured-parameters": "Paramètres mesurés sélectionnés",
    "digest-options": "Options d'extraction",
    "out-of-range-export-dateTo-before-dateFrom": "La date de fin ne peut pas être avant la date de début.",
    "min-max-out-of-range-from": "Les données sont disponible du"
  },
  "de": {

  }
}
</i18n>

<template>
  <md-dialog class="export-modal" :md-active="show" v-if="observationPoint !== null">
    <md-dialog-title>{{ $t(showDigest ? 'export-digest-title' : 'export-data-title') }} {{ observationPoint.name }}</md-dialog-title>
    <md-dialog-content>
      <div class="modal-content" v-if="!loading && showExportParameters && !showDigest">
        <h3>{{ $t('measured-parameters') }}</h3>
        <div class="measured-parameters">
          <div v-for="parameterType in availableParameterTypes" :key="parameterType.id">
            <md-checkbox v-model="selectedParameterTypeIds" :value="parameterType.id">{{ parameterType.name[$i18n.locale] }}</md-checkbox>
            <span class="temporal-range">{{ $t ('available-data-from')}} {{ getMinDate(parameterType) }} {{ $t ('available-data-to')}} {{ getMaxDate(parameterType) }}</span>
          </div>
        </div>

        <h3>{{ $t('aggregation-option') }}</h3>
        <div class="aggregation-option">
          <md-field class="extract-data-option">
            <label for="aggregationMode">{{ $t('aggregation-mode') }}</label>
            <md-select v-model="selectedAggregationMode" name="aggregation-mode" md-dense>
              <md-option value="RAW">{{ $t('raw') }}</md-option>
              <md-option value="DD">{{ $t('dd') }}</md-option>
              <md-option value="MM">{{ $t('mm') }}</md-option>
              <md-option value="YYYY">{{ $t('yyyy') }}</md-option>
            </md-select>
          </md-field>

          <md-field v-if="showStatsSelection" class="extract-data-option">
            <label for="stats">{{ $t('stats') }}</label>
            <md-select v-model="selectedStats" name="stats" md-dense multiple>
              <md-option value="MIN">{{ $t('MIN') }}</md-option>
              <md-option value="MAX">{{ $t('MAX') }}</md-option>
              <md-option value="AVG">{{ $t('AVG') }}</md-option>
            </md-select>
          </md-field>
        </div>

        <h3>{{ $t('date-selection') }}</h3>
        <div class="out-of-range-error">
          <span v-if="!isExportRangeValid && selectedAggregationMode === 'RAW'">{{ $t('out-of-range-export-raw') }}</span>
          <span v-if="!isExportRangeValid && selectedAggregationMode === 'DD'">{{ $t('out-of-range-export-dd') }}</span>
          <span v-if="dateToIsBeforeDateFrom">{{$t('out-of-range-export-dateTo-before-dateFrom')}}</span>
          <span v-if="isDateFromBeforeMinDate || isDateToAfterMaxDate">{{ $t('min-max-out-of-range-from') }} {{ extractMinDate | formatDate }} {{ $t('available-data-to') }} {{ extractMaxDate | formatDate }}</span>
        </div>

        <div class="date-selection">
          <md-datepicker :class="['extract-date-option', { 'md-invalid': !isExportRangeValid || isDateFromBeforeMinDate }]"
            v-model="extractDateFrom"
            :md-disabled-dates="disableExtractDates"
            :md-immediately="true"
            :md-open-on-focus="false"
            @md-opened="onDateFromOpen"
          >
            <label>{{$t('from')}}</label>
          </md-datepicker>
          <md-datepicker :class="['extract-date-option', { 'md-invalid': !isExportRangeValid || isDateToAfterMaxDate }]"
            v-model="extractDateTo"
            :md-disabled-dates="disableExtractDates"
            :md-immediately="true"
            :md-open-on-focus="false"
            @md-opened="onDateToOpen"
          >
            <label>{{$t('to')}}</label>
          </md-datepicker>
        </div>

        <div class="date-option">
          <md-field class="utc-offset">
            <label>{{ $t('utc-offset') }}</label>
            <md-input v-model="selectedUtcOffset" type="number"></md-input>
          </md-field>
          <md-button class="md-raised" @click="resetExtractDateToBound(true)">{{ $t('reset-bounds') }}</md-button>
        </div>

        <h3>{{ $t('other-option') }}</h3>
        <div class="other-option">
          <md-field>
            <label>{{ $t('nodata-value') }}</label>
            <md-input type="number" v-model="selectedNodataValue"></md-input>
          </md-field>
        </div>
      </div>

      <div class="modal-content export-digest" v-if="!loading && showExportParameters && showDigest">
        <h3>{{ $t('digest-measured-parameters') }}</h3>
        <div>
          <ul>
            <li v-for="parameterType in selectedParameterTypes" :key="parameterType.id" :class="['digest-measured-parameter', {'disabled': isExtractOutOfRange(parameterType)}]">
              <b>{{ parameterType.name[$i18n.locale] }}</b>
              <ul v-if="!isExtractOutOfRange(parameterType)">
                <li>
                  {{ $t('digest-extract-from') }} {{ getExtractFrom(parameterType) }} {{ $t('digest-extract-from-time') }} ({{ utcOffsetDisplay }})
                </li>
                <li>
                  {{ $t('digest-extract-to') }} {{ getExtractTo(parameterType) }} {{ $t('digest-extract-to-time') }} ({{ utcOffsetDisplay }})
                </li>
              </ul>
              <ul v-if="isExtractOutOfRange(parameterType)">
                <li>
                  {{ $t('extract-out-of-range') }} {{ $t ('available-data-from')}} {{ getMinDate(parameterType) }} {{ $t ('available-data-to')}} {{ getMaxDate(parameterType) }}
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <h3>{{ $t('digest-options') }}</h3>
        <div>
          <ul>
            <li><b>{{ $t('aggregation-mode') }}</b>: {{ $t(selectedAggregationMode) }}</li>
            <li v-if="selectedStats.length > 0"><b>{{ $t('stats') }}</b>: {{ $t(selectedStats) }}</li>
            <li><b>{{ $t('nodata-value') }}</b>: {{ selectedNodataValue }}</li>
          </ul>
        </div>
      </div>

      <div class="export-step" v-if="isExportRunning">
        <md-progress-spinner class="loading-animation" :md-diameter="22" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner> <span style="margin-left: 15px;">{{ $t(`run-step-${runStep}`) }}</span>
      </div>

      <div class="export-action" v-if="!loading && !showDigest">
        <md-button class="md-primary md-raised" :disabled="disableLaunchExport || !isExportRangeValid" v-if="!canDownloadFile && !isExportRunning" @click="showDigest = true">{{ $t('next') }}</md-button>
      </div>

      <div class="export-action" v-if="!loading && showDigest">
        <md-button class="md-raised" @click="showDigest = false">{{ $t('return') }}</md-button>
        <md-button :class="['md-primary', 'md-raised']" :disabled="disableLaunchExport || !isExportRangeValid" v-if="!canDownloadFile && !isExportRunning" @click="run">{{ $t('launch-export') }}</md-button>
      </div>

      <div class="download-action" v-if="canDownloadFile">
        <md-button :class="['md-raised', {'md-primary': !alreadyClickOnDownload}]" @click="download">{{ $tc('download-file', files.length) }}</md-button>
        <md-button @click="resetExport">{{ $t('reset-export') }}</md-button>
      </div>

      <div class="loading" v-if="loading">
        <md-progress-spinner class="loading-animation" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="closeModal" :disabled="isExportRunning">{{ $t('close') }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import ExportTool from '@/utils/export'
import FileUtils from '@/utils/file'

import ObservationPointProxy from '@/proxies/observationPoint'
import TimeseriesProxy from '@/proxies/timeseries'

function initialStateExportModal() {
  return {
    loading: true,
    datasources: [],
    selectedParameterTypeIds: [],
    extractDateFrom: null,
    extractDateTo: null,
    selectedStats: ['AVG'],
    selectedAggregationMode: 'MM',
    selectedUtcOffset: 1,
    selectedNodataValue: -9999,
    runStep: null,
    runError: null,
    files: [],
    showDigest: false,
    alreadyClickOnDownload: false
  }
}

export default {
  name: 'ExportDataModal',
  components: {

  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    observationPoint: {
      type: Object,
      default: () => { return {} }
    }
  },
  filters: {
    formatDate (momentDate) {
      return momentDate.format('DD.MM.YYYY')
    }
  },
  computed: {
    availableParameterTypes () {
      // On ne prend pas en compte les sources de données vide
      let availableDatasources = this.datasources.filter((datasource) => datasource.stats.minDate !== null)
      let toReturn = availableDatasources.map((datasource) => { return datasource.parameterType })
      toReturn = _.uniqBy(toReturn, 'id')
      toReturn = _.sortBy(toReturn, 'id')
      return toReturn
    },
    selectedParameterTypes () {
      return this.availableParameterTypes.filter((parameterType) => this.selectedParameterTypeIds.includes(parameterType.id))
    },
    selectedDatasources () {
      // Filtre des sources de données disponibles avec le(s) paramères mesurés sélectionnés. On ne prend pas en compte les sources de données vide
      return this.datasources.filter((datasource) => this.selectedParameterTypeIds.includes(datasource.parameterType.id) && datasource.stats.minDate !== null)
    },
    dateFrom () {
      return moment.utc(this.extractDateFrom, 'DD.MM.YYYY').utcOffset(this.utcOffset, true).toISOString()
    },
    dateTo () {
      return moment.utc(this.extractDateTo, 'DD.MM.YYYY').utcOffset(this.utcOffset, true).toISOString()
    },
    extractMinDate () {
      let toReturn = null
      let tmp = null

      this.selectedDatasources.forEach((datasource) => {
        tmp = moment.utc(datasource.stats.minDate)
        if (toReturn === null || toReturn.isSameOrAfter(tmp)) toReturn = tmp
      })

      return toReturn
    },
    extractMaxDate () {
      let toReturn = null
      let tmp = null

      this.selectedDatasources.forEach((datasource) => {
        tmp = moment.utc(datasource.stats.maxDate)
        if (toReturn === null || toReturn.isSameOrBefore(tmp)) toReturn = tmp
      })

      return toReturn
    },
    showStatsSelection () {
      return this.selectedAggregationMode !== 'RAW'
    },
    disableLaunchExport () {
      return this.extractDateFrom === null || this.extractDateTo === null || this.selectedParameterTypeIds.length === 0 || this.runStep !== null || (this.selectedStats.length === 0 && this.selectedAggregationMode !== 'RAW')
    },
    canDownloadFile () {
      return this.runStep === null && this.files.length > 0
    },
    showExportParameters () {
      return this.runStep === null && this.files.length === 0
    },
    isExportRunning () {
      return this.files.length === 0 && this.runStep !== null
    },
    utcOffset () {
      return parseInt(this.selectedUtcOffset) * 60
    },
    utcOffsetDisplay () {
      return `UTC${this.utcOffset >= 0 ? '+' : ''}${this.utcOffset / 60}`
    },
    isExportRangeValid () {
      let exportRange = moment.utc(this.dateTo).diff(moment.utc(this.dateFrom), 'years')
      if (this.selectedAggregationMode === 'RAW' && exportRange > 2) return false
      if (this.selectedAggregationMode === 'DD' && exportRange > 10) return false

      return true && !this.dateToIsBeforeDateFrom
    },
    dateToIsBeforeDateFrom () {
      return moment.utc(this.dateTo).isBefore(moment.utc(this.dateFrom), 'day')
    },
    isDateFromBeforeMinDate () {
      return moment.utc(this.dateFrom).isBefore(moment.utc(this.extractMinDate).subtract(1, 'day'), 'day')
    },
    isDateToAfterMaxDate () {
      return moment.utc(this.dateTo).isAfter(this.extractMaxDate, 'day')
    },
  },
  watch: {
    show (){
      if (this.show) {
        this.loading = true
        this.load().then(() => {
          this.resetExtractDateToBound()
          this.loading = false
        }).catch(this.handleError)
      }
    },
    selectedParameterTypeIds () {
      this.files = []
      if (this.selectedParameterTypeIds.length === 0) {
        this.extractDateFrom = null
        this.extractDateTo = null
      } else this.resetExtractDateToBound()
    },
    selectedAggregationMode (){
      this.files = []

      if (this.selectedAggregationMode === 'RAW') this.selectedStats = []
    }
  },
  data() {
    return initialStateExportModal()
  },
  methods: {
    closeModal () {
      this.$emit('close')
      Object.assign(this.$data, initialStateExportModal())
    },
    handleError (e) {
      console.error(e)
    },
    load () {
      return new Promise((resolve, reject) => {
        ObservationPointProxy.listExportableDatasource(this.observationPoint.id).then((datasources) => {
          this.datasources = datasources
          resolve()
        }).catch(reject)
      })
    },
    onDateFromOpen () {
      if (this.extractDateFrom === null) this.extractDateFrom = moment.utc(this.extractMinDate).format('DD.MM.YYYY')
    },
    onDateToOpen () {
      if (this.extractDateTo === null) this.extractDateTo = moment.utc(this.extractMaxDate).format('DD.MM.YYYY')
    },
    resetExtractDateToBound (force = false) {
      if (!force && (_.isEmpty(this.extractMinDate) || _.isEmpty(this.extractMaxDate))) return

      if (
        force ||
        this.extractDateFrom === null ||
        moment.utc(this.extractDateFrom, 'DD.MM.YYYY').isSameOrBefore(this.extractMinDate) ||
        moment.utc(this.extractDateFrom, 'DD.MM.YYYY').isSameOrAfter(this.extractMaxDate)
      ) {
        this.extractDateFrom = this.extractMinDate.format('DD.MM.YYYY')
      }
      if (
        force ||
        this.extractDateTo === null ||
        moment.utc(this.extractDateTo, 'DD.MM.YYYY').isSameOrBefore(this.extractMinDate) ||
        moment.utc(this.extractDateTo, 'DD.MM.YYYY').isSameOrAfter(this.extractMaxDate)
      ) {
        this.extractDateTo = this.extractMaxDate.format('DD.MM.YYYY')
      }
    },
    disableExtractDates (date) {
      if (_.isEmpty(this.extractMinDate) || _.isEmpty(this.extractMaxDate)) return false
      return !(this.extractMinDate.isSameOrBefore(date) && this.extractMaxDate.isSameOrAfter(date))
    },
    run () {
      this.showDigest = false
      this.runError = null
      this.runStep = 'fetch'
      this.fetchTimeserise().then((exportResults) => {
        this.runStep = 'merge'
        this.mergeData(exportResults).then((timeseries) => {
          this.runStep = 'generate'
          this.generateFile(timeseries).then(() => {
            this.runStep = null
          }).catch((e) => this.handleExportError(e, 'generate-error'))
        }).catch((e) => this.handleExportError(e, 'merge-error'))
      }).catch((e) => this.handleExportError(e, 'fetch-error'))
    },
    handleExportError (e, msgCode) {
      this.runStep = null
      this.runError = msgCode
      console.error(e, msgCode)
    },
    fetchTimeserise () {
      return new Promise((resolve, reject) => {
        let toFetch = []

        this.selectedDatasources.forEach((datasource) => {
          toFetch.push(TimeseriesProxy.export({
            datasourceId: datasource.id,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            aggregationMode: this.selectedAggregationMode.toLowerCase(),
            stats: this.selectedStats[0] // Renvoit dans tous les cas toutes les stats disponibles
          }))
        })

        Promise.all(toFetch).then((results) => {
          resolve(results)
        }).catch(reject)
      })
    },
    dealData (d, stats) {
      let statsField = null
      let parseData = true

      switch (stats) {
        case 'MIN':
          statsField = 'minValue'
          break
        case 'MAX':
          statsField = 'maxValue'
          break
        case 'AVG':
          statsField = 'avgValue'
          break
        case 'RAW':
          statsField = 'value'
          break
        default:
          statsField = stats
          parseData = false
          break
      }

      return {
        event: d.event,
        value: parseData ? parseFloat(d[statsField]).toFixed(2) : d[statsField],
        count: typeof d.count === 'undefined' ? 1 : d.count
      }
    },
    mergeData (exportResults) {
      return new Promise((resolve, reject) => {
        let dataToExport = []

        let validatedDatasource = null
        let validatedDataIndex = null
        let remoteDatasource = null
        let remoteDataIndex = null
        let tmpData = new Map()

        try {
          // Mise en commun des données pour ne former qu'une seul chronique par paramètre mesuré
          // La chronique finale = données télétransmises + données validées (les données validées écrasent l'éventuel relicat de données télétransmises)
          this.selectedParameterTypes.forEach((selectedParameterType) => {
            // Initalisation des variables
            validatedDatasource = null
            validatedDataIndex = null
            remoteDatasource = null
            remoteDataIndex = null
            tmpData = new Map()

            // Récupération des deux sources de données pour le paramètre mesuré
            validatedDatasource = this.selectedDatasources.find((datasource) => datasource.parameterType.id === selectedParameterType.id && datasource.datasourceType.code === 'validated')
            validatedDataIndex = this.selectedDatasources.indexOf(validatedDatasource)
            remoteDatasource = this.selectedDatasources.find((datasource) => datasource.parameterType.id === selectedParameterType.id && datasource.datasourceType.code === 'remote')
            remoteDataIndex = this.selectedDatasources.indexOf(remoteDatasource)

            // Mise en commun des deux sources de données (si elles existent).
            // Ajout du flag "rangeCd" pour indiquer "provisiore" ou "validé"
            if (remoteDataIndex >= 0) exportResults[remoteDataIndex].map((d) => { d.rangeCd = this.$t('remote'); return d }).forEach((d) => tmpData.set(d.event, d))
            if (validatedDataIndex >= 0) exportResults[validatedDataIndex].map((d) => { d.rangeCd = this.$t('validated'); return d }).forEach((d) => tmpData.set(d.event, d))

            // Sauvegarde de la chronique à exporter. On conserve uniquement le type d'aggrégation demandé
            dataToExport.push({
              parameterType: selectedParameterType,
              data: Array.from(tmpData.values())
            })
          })
        } catch(e) { return reject(e) }

        resolve(dataToExport)
      })
    },
    generateFile (timeseries) {
      return new Promise((resolve, reject) => {
        try {
          // Création de la structure de donnée nécessaire pour l'outil d'export
          let taskList = []
          let task = {}
          timeseries.forEach((timeserie) => {
            task = {
              key: `obspoint_${this.observationPoint.id}_${timeserie.parameterType.code}`,
              objectId: `${this.observationPoint.id}_${timeserie.parameterType.code}`,
              objectName: `${this.observationPoint.name}_${timeserie.parameterType.code}`,
              downloadType: 'station',
              dataSource: timeserie.parameterType,
              aoi: _.cloneDeep(this.observationPoint),
              aoiType: 'station',
              data: []
            }

            // Formattage et ajout des données suivant leur mode d'aggrégation
            if (this.selectedStats.length === 0 && this.selectedAggregationMode === 'RAW') {
              task.data.push({
                header: {
                  id: timeserie.parameterType.id,
                  name: timeserie.parameterType.name[this.$i18n.locale],
                  unit: {
                    id: timeserie.parameterType.unit.id,
                    name: timeserie.parameterType.unit.name[this.$i18n.locale],
                    symbol: timeserie.parameterType.unit.symbol[this.$i18n.locale],
                  },
                  type: 'observation',

                },
                data: timeserie.data.map((d) => this.dealData(d, 'RAW'))
              })
            } else {
              this.selectedStats.forEach((stats) => {
                task.data.push({
                  header: {
                    id: `${timeserie.parameterType.id}_${stats}`,
                    name: `${timeserie.parameterType.name[this.$i18n.locale]} - ${this.$t(stats)}`,
                    unit: {
                      id: timeserie.parameterType.unit.id,
                      name: timeserie.parameterType.unit.name[this.$i18n.locale],
                      symbol: timeserie.parameterType.unit.symbol[this.$i18n.locale],
                    },
                    type: 'observation',

                  },
                  data: timeserie.data.map((d) => this.dealData(d, stats))
                })
              })
            }

            // Ajout du flag "rangeCd" pour indiquer "provisiore" ou "validé"
            task.data.push({
              header: {
                id: `${timeserie.parameterType.id}_rangeCd`,
                name: '',
                unit: ExportTool.emptyUnit,
                type: 'observation',

              },
              data: timeserie.data.map((d) => this.dealData(d, 'rangeCd'))
            })
            taskList.push(task)
          })

          this.files = ExportTool.taskListToCsv(taskList, 'aoi', 'station', this.selectedAggregationMode, this.dateFrom, this.dateTo, this.selectedNodataValue, 'DD.MM.YYYY HHM:mm:SS', this.utcOffset)
          // Ajout du header pour chaque fichier
          this.files.forEach((file, i) => file.data = this.generateHeader(timeseries[i]) + file.data)
        } catch (e) { return reject(e) }

        resolve()
      })
    },
    generateHeader (timeserie) {
      let countRemoteData = timeserie.data.filter((d) => d.rangeCd === this.$t('remote')).length
      let countValidatedData = timeserie.data.filter((d) => d.rangeCd === this.$t('validated')).length

      let rows = []
      rows.push([`${this.$t('observation-point-csv-label')}:`, this.observationPoint.name])
      rows.push([`${this.$t('public-id-label')}:`, this.observationPoint.publicId])
      rows.push([`${this.$t('aggregation-mode-label')}:`, this.$t(this.selectedAggregationMode.toLowerCase())])
      rows.push([`${this.$t('needed-stats-label')}:`, this.$t(this.selectedStats)])
      rows.push([`${this.$t('date-range-label')}:`, `${this.extractDateFrom} - ${this.extractDateTo}`])
      rows.push([`${this.$t('utc-offset')}:`, this.utcOffsetDisplay])
      rows.push([`${this.$t('count-validated-label')}:`, `${countValidatedData}`])
      rows.push([`${this.$t('count-remote-label')}:`, `${countRemoteData}`])
      rows.push([`${this.$t('nodata-value')}:`, `${this.selectedNodataValue}`])

      rows = rows.map((row) => row.join(','))

      return rows.join('\r\n') + '\r\n'
    },
    download () {
      this.alreadyClickOnDownload = true

      if (this.files.length === 0) { return }
      else if (this.files.length === 1) {
        let file = _.head(this.files)
        FileUtils.download(file.name, file.data)
      } else {
        let fileName = `${moment.utc(this.dateFrom).format('YYYYMMDD')}_${moment.utc(this.dateTo).format('YYYYMMDD')}_${this.selectedAggregationMode}_${this.observationPoint.name}`
        FileUtils.downloadAsZip(fileName, this.files)
      }
    },
    resetExport () {
      this.files = []
    },
    getMinDate (parameterType) {
      let availableDatasources = this.datasources.filter((datasource) => datasource.parameterType.id === parameterType.id)
      if (availableDatasources.length === 0) return '-'

      let toReturn = moment.utc(_.head(availableDatasources).stats.minDate)
      availableDatasources.forEach((datasource) => {
        if (toReturn.isAfter(datasource.stats.minDate)) toReturn = moment.utc(datasource.stats.minDate)
      })
      return toReturn.format('DD.MM.YYYY')
    },
    getMaxDate (parameterType) {
      let availableDatasources = this.datasources.filter((datasource) => datasource.parameterType.id === parameterType.id)
      if (availableDatasources.length === 0) return '-'

      let toReturn = moment.utc(_.head(availableDatasources).stats.maxDate)
      availableDatasources.forEach((datasource) => {
        if (toReturn.isBefore(datasource.stats.maxDate)) toReturn = moment.utc(datasource.stats.maxDate)
      })
      return toReturn.format('DD.MM.YYYY')
    },
    getExtractFrom (parameterType) {
      let dateFrom = moment.utc(this.dateFrom)
      let minDateAvailable = moment.utc(this.getMinDate(parameterType), 'DD.MM.YYYY')
      let toReturn = dateFrom
      if (minDateAvailable.isAfter(dateFrom)) toReturn = minDateAvailable
      return toReturn.format('DD.MM.YYYY')
    },
    getExtractTo (parameterType) {
      let dateTo = moment.utc(this.dateTo)
      let maxDateAvailable = moment.utc(this.getMaxDate(parameterType), 'DD.MM.YYYY')
      let toReturn = dateTo
      if (dateTo.isAfter(maxDateAvailable)) toReturn = maxDateAvailable
      return toReturn.format('DD.MM.YYYY')
    },
    isExtractOutOfRange (parameterType) {
      let selectedDateTo = moment.utc(this.dateTo)
      let minDateAvailable = moment.utc(this.getMinDate(parameterType), 'DD.MM.YYYY')
      return selectedDateTo.isBefore(minDateAvailable)
    }
  }
}

</script>

<style lang="scss">
  .export-modal {
    .md-dialog-container {
      width: 500px !important;
      max-height: 85%;

      .md-dialog-title {
        font-weight: 600;
        text-align: center;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .loading {
    padding: 50px;
  }

  .modal-content {
    padding: 15px;
    padding-top: 0px;
    padding-bottom: 0px;

    h3 {
      color: #4c4c4c;
      font-weight: normal;
      border-bottom: 1px solid #949494;
      margin-top: 15px;
      margin-bottom: 10px;
    }
  }

  .export-step {
    display: flex;
    justify-content: center;
    padding: 50px;
  }

  .measured-parameters {
    display: flex;
    flex-direction: column;

    .md-checkbox {
      margin: 7px 16px 7px 16px;
    }

    .temporal-range {
      display: block;
      margin-left: 65px;
      margin-top: -10px;
      font-size: 13px;
    }
  }

  .date-selection {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    padding-left: 15px;
    padding-right: 15px;

    .md-field {
      margin: 4px 0 4px;
    }
  }

  .date-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;

    padding-left: 15px;
    padding-right: 15px;

    .md-button {
      margin-bottom: 10px;
    }

    .md-field.utc-offset {
      width: 75px;
      margin-left: 4px;
      input { width: 75px; }
    }
  }

  .aggregation-option {
    display: flex;
    justify-content: space-around;
    padding-left: 15px;
    padding-right: 15px;

    .md-field {
      width: 165px;
    }
  }

  .other-option {
    display: flex;
    justify-content: space-around;
    padding-left: 15px;
    padding-right: 15px;
  }

  .export-action {
    display: flex;
    justify-content: center;
  }

  .download-action {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 50px;
    padding-bottom: 20px;
  }

  .out-of-range-error {
    text-align: center;
    font-style: italic;
    color: #ff5252;
  }

  .export-digest {
    .digest-measured-parameter {
      &.disabled {
        color: #c5c2c2;
      }
    }
  }
</style>
